import { ArrowLeftOnRectangleIcon, ArrowRightOnRectangleIcon, ExclamationTriangleIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';
import { useEffect, useState } from 'react';
import { useLogoutMutation } from '../redux/loginApi';
import {useGetLoginQuery, useLoginEmailMutation} from '../redux/loginApi';
import LoadingSpinner from './LoadingSpinner';
import ModalError from './Modal/ModalError';
import ModalLoading from './Modal/ModalLoading';
import useAccessLevel from '../hooks/useAccessLevel';
import ModalAdminOptions from './Modal/ModalAdminOptions';
import ModalLogin from './Modal/ModalLogin';

export default function HeaderUserActions({}){
    const { data: user, error: userError, isLoading: userIsLoading } = useGetLoginQuery(); 
    const [logout, { error: logoutError, isLoading: isLoggingOut, isSuccess: isLogoutSuccess }] = useLogoutMutation();
    const [error, setError] = useState(null);
    const [showAdminOptions, setShowAdminOptions] = useState(false);
    const isAdmin = useAccessLevel('admin');
    const [showLoginModal, setShowLoginModal] = useState(false);

    useEffect(()=>{
        if(logoutError){
            setError(logoutError.data);
        }else if(isLogoutSuccess){
            window.location.reload();
        }
    }, [isLogoutSuccess, logoutError]);

    return (
        <div>
            {showLoginModal && <ModalLogin callback={()=>setShowLoginModal(false)} />}
            {( userError && (
                <div>
                    <button type="button" title={userError.message}> 
                        <ExclamationTriangleIcon className='w-4' />
                        <span>Login Error</span>
                    </button>
                </div>
            )) || ( userIsLoading && (
                <div>
                    <button type="button" disabled={true} title="Logging in..."> 
                        <LoadingSpinner className="w-8" />
                    </button>
                </div>
            )) || ( !user && (
                <div>
                    <button type="button" className='flex items-center hover:bg-gray-100 px-2 py-1 rounded-md' onClick={()=>setShowLoginModal(true)}> 
                        <ArrowRightOnRectangleIcon className='w-4 mr-2' />
                        <span>Log In / Sign Up</span>
                    </button>
                </div>
            )) || (
                <div className='flex'>
                    { isLoggingOut && <ModalLoading title="Logging Out" />}
                    { error && <ModalError message={error.message} callback={()=>setError(null)} /> }
                    <button 
                        type="button" 
                        className='mr-2 p-2 text-truncate border-b border-transparent hover:border-black hover:bg-gray-100 transition-colors' 
                        disabled={true} 
                        title={`Your are logged in as ${user.email}`}
                    >
                            {user.email}
                    </button>
                    {isAdmin && <button 
                        type="button" 
                        className='mr-2 p-2 border-b border-transparent hover:border-black hover:bg-gray-100 transition-colors text-yellow-600' 
                        title="Admin Options" 
                        onClick={()=>setShowAdminOptions(true)}
                    >
                            <ShieldCheckIcon className='w-6' />
                    </button>}
                    <button 
                        type="button" 
                        className='mr-2 p-2 border-b border-transparent hover:border-black hover:bg-gray-100 transition-colors' 
                        title="Log Out" 
                        onClick={()=>logout()}
                    >
                            <ArrowLeftOnRectangleIcon className='w-6' />
                    </button>
                    {showAdminOptions && <ModalAdminOptions callback={()=>setShowAdminOptions(false)} /> }
                </div>
            )}
        </div>
    );
}